"use client";
import { useState, useEffect } from "react";

export default function BlogQuestionsAside({ questions }) {
  const [active, setActive] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      let current = null;

      questions.forEach((q) => {
        const el = document.getElementById(`question-${q.contentIndex}`);
        if (!el) return;

        const rect = el.getBoundingClientRect();

        // adjust this offset based on your header height
        const offset = 120;

        if (rect.top <= offset) {
          current = q.contentIndex;
        }
      });

      if (current !== null) {
        setActive(current);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // run once on load
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, [questions]);

  const handleClick = (id) => {
    const el = document.getElementById(`question-${id}`);
    if (!el) return;

    const yOffset = -100; // adjust for sticky header
    const y =
      el.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });

    setActive(id);
  };

  return (
    <div className="sticky top-24 w-80 p-4 rounded-xl space-y-2">
      {questions.map((q) => {
        const isActive = active === q.contentIndex;

        return (
          <button
            key={q.contentIndex}
            onClick={() => handleClick(q.contentIndex)}
            className={`w-full text-left px-3 py-2 rounded-md transition-all duration-200 cursor-pointer
              ${
                isActive
                  ? "bg-blue-100 font-semibold border-l-4 border-blue-500"
                  : "hover:bg-blue-50"
              }`}
          >
            {q.question}
          </button>
        );
      })}
    </div>
  );
}